import React from 'react';
import ReactDOM from 'react-dom/client';
import Questionnaire from './Questionnaire';
import './index.css';
import './animations.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Questionnaire />
  </React.StrictMode>
);
